import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavItem, Nav, TabContent, TabPane, NavLink } from 'reactstrap';
import CustomFields from '../CustomFields';

class TabField extends Component {

  state = { activeTab: 0 }

  handleTabChange = (key) => {
    this.setState({ activeTab : key })
  }

  handleTabFieldChange = (key, value) => {
    let custom = this.props.value || {}
    custom[key] = value

    this.props.onChange({
      value: custom
    })
  }

  renderTabItems = (activeTab) => {
    const tab = this.props.config.tabs[activeTab]
    
    if(!tab)
      return

    const tabsItems = (this.props.config.tabs).map(tab => tab.items)

    return (
      <TabContent activeTab={activeTab}>
        {tabsItems.map((tabItems, tabIdx) => 
            <TabPane key={tabIdx} tabId={tabIdx}>
              <CustomFields
                config={tabItems}
                onChange={this.handleTabFieldChange}
                custom={this.props.value}
                activeTab={activeTab}
                extra={this.props.extra}
              />
          </TabPane>
        )}  
      </TabContent>
    )
  }

  renderTabLabels = () => {

    if(!this.props.config.tabs){
      return
    }

    return this.props.config.tabs.map((tab, idx) => 
      <NavItem 
        key={idx}
        className={idx === this.state.activeTab ? "active" : ''}
        onClick={() => this.handleTabChange(idx)}>
        <NavLink>{tab.name}</NavLink>
      </NavItem>
    )
  }

  render () {
    return (
      <div>
        <Nav tabs>{this.renderTabLabels()}</Nav>
        <br/>
        {this.renderTabItems(this.state.activeTab)}
        <hr/>
      </div>
    )
  }
}

TabField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.any,
  extra: PropTypes.object
}

export default TabField;
